export const qs = <T extends Element = Element>(sel: string, root: Document | Element = document) => {
    const result = root.querySelector<T>(sel);
    if (!result) {
        throw new Error(`Element not found: ${sel}`);
    }
    return result;
};
export const qsa = (sel: string, root: Document | Element = document) =>
    Array.from(root.querySelectorAll(sel));

export function el<K extends keyof HTMLElementTagNameMap>(
    tag: K,
    attrs: Record<string, any> = {},
    ...children: (Node | string | null | undefined)[]
): HTMLElementTagNameMap[K] {
    const node = document.createElement(tag);
    for (const [k, v] of Object.entries(attrs)) {
        if (v === null || v === undefined) continue;
        if (k === "class") node.className = v;
        else if (k.startsWith("on") && typeof v === "function") node.addEventListener(k.slice(2), v as EventListener);
        else node.setAttribute(k, String(v));
    }
    for (const c of children) {
        if (c == null) continue;
        node.append(c instanceof Node ? c : document.createTextNode(String(c)));
    }
    return node;
}

export function clear(elm: Element) { while (elm.firstChild) elm.removeChild(elm.firstChild); }
